import { useEffect, useState } from "react";
import { axiosFunction } from "../axiosFunction";
import { smaartCardUrl } from "../constant";

export const useCity = () => {
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    const getCity = async () => {
      const cityRes = await axiosFunction(
        `${smaartCardUrl}/location/api/city/24`,
        "GET",
        null
      );

      setCityList(cityRes?.data);
    };
    getCity();
  }, []);

  return { cityList };
};
